import {
  IDistrictCreate,
  IDistrictDetails,
  IDistrictListSearch,
  IGetDistrictList,
  IEditDistrictPayload,
} from "../../../types/master/districtInterface";
import { DistrictActionTypes, DistrictActions } from "../../actionTypes/master/districtActionTypes";

export const createDistrict = (payload: IDistrictCreate): DistrictActionTypes => ({
  type: DistrictActions.CREATE_DISTRICT,
  payload,
}); 

export const getDistrictList = (payload: IDistrictListSearch): DistrictActionTypes => ({
  type: DistrictActions.GET_DISTRICT_LIST,
  payload,
});

export const setDistrictList = (branchList: Array<IGetDistrictList>) : DistrictActionTypes => ({
  type: DistrictActions.SET_DISTRICT_LIST,
  payload: branchList
})

export const setDistrictListPageCount = (payload:number): DistrictActionTypes => ({
  type: DistrictActions.SET_DISTRICT_LIST_PAGE_COUNT,
  payload
})

export const getDistrictDataById = (id: number | string): DistrictActionTypes => ({
  type: DistrictActions.GET_DISTRICT_DATA_BY_ID,
  payload: id
})

export const setDistrictDataById = (payload: IDistrictDetails) => ({
  type: DistrictActions.SET_DISTRICT_DATA_BY_ID,
  payload
})

export const editDistrict = (payload: IEditDistrictPayload): DistrictActionTypes => ({
  type: DistrictActions.EDIT_DISTRICT_DATA_BY_ID,
  payload,
});

export const deleteDistrict = (id: number): DistrictActionTypes => ({
  type: DistrictActions.DELETE_DISTRICT,
  payload: id,
});

